import { useMemo } from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { RouteManagerFactory } from "routes"
import { UserSlice } from "store"
import { AppRoute } from "enums/routes"
import * as permissionType from "enums/permissionType"
import { Some } from "lib/opt"

export function UseRouteManager() {
	const perms = useSelector(UserSlice.selectors.selectUserPermissions)
	return useMemo(() => RouteManagerFactory(perms), [perms])
}

export function UseCurrentRoute(): Opt<AppRoute> {
	const routeManager = UseRouteManager()
	const location = useLocation()
	return useMemo(() => routeManager.GetCurrRoute(location.pathname), [routeManager, location])
}


// export function useIsAdmin() {
//   const roleManager = useRoleManager();
//   const currRoute = useCurrentRoute();
//   return roleManager
//     .getPermissonTypeForRoute(currRoute.expect('No route found'))
//     .is()
//     .Admin();
// }

export function UseIsRouteAccessible(): Opt<bool> {
	const currRoute = UseCurrentRoute()
	return Some<bool>(true);
  }
